import { useState } from "react";
import { Film, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { img, errMsg } from "../lib/api";
import { uploadVideo } from "../lib/video";

export default function VideoField({ videos, setVideos, max = 3, testid = "video" }) {
  const [pct, setPct] = useState(null);
  const pick = async (file) => {
    if (!file) return;
    setPct(0);
    try { const url = await uploadVideo(file, setPct); setVideos([...videos, url]); toast.success("Video uploaded"); }
    catch (e) { toast.error(e.response ? errMsg(e) : e.message); } finally { setPct(null); }
  };
  return (
    <div className="space-y-2" data-testid={`${testid}-field`}>
      <div className="flex flex-wrap gap-2">
        {videos.map((v) => (
          <div key={v} className="relative w-44 h-28 rounded-xl overflow-hidden border border-white/10 bg-black">
            <video src={img(v)} className="w-full h-full object-cover" controls playsInline preload="metadata" data-testid={`${testid}-preview`} />
            <button type="button" data-testid={`${testid}-remove`} onClick={() => setVideos(videos.filter((x) => x !== v))} className="absolute top-1 right-1 p-1 rounded-full bg-black/70"><X size={12} /></button>
          </div>
        ))}
        {videos.length < max && (
          <label className="w-28 h-20 rounded-xl border border-dashed border-white/20 grid place-items-center text-[11px] text-slate-400 cursor-pointer text-center hover:border-[#ff5500]/60">
            {pct !== null ? <span className="flex items-center gap-1"><Loader2 size={14} className="animate-spin" />{pct}%</span> : <span className="flex flex-col items-center gap-1"><Film size={16} className="text-[#ff5500]" />Add video</span>}
            <input data-testid={`${testid}-input`} type="file" accept="video/mp4,video/webm,video/quicktime" hidden disabled={pct !== null} onChange={(e) => pick(e.target.files[0])} />
          </label>
        )}
      </div>
      <p className="text-[11px] text-slate-500">MP4, WEBM or MOV · up to 50 MB · about 1 minute</p>
    </div>
  );
}
